import login from '@/app-modulo/documento/login/router'
import loginExterno from '@/app-modulo/documento/login-externo/router'
import proprietario from '@/app-modulo/comuns/proprietario/router'
import funcao from '@/app-modulo/comuns/funcao/router'
import equipe from '@/app-modulo/comuns/equipe/router'
import departamentos from '@/app-modulo/comuns/departamentos/router'
import dashboard from '@/app-modulo/documento/dashboard/router'
import usuariosExternos from '@/app-modulo/comuns/usuario-externo/router'
import grupoUsuario from '@/app-modulo/comuns/grupo-usuario/router'
import emailConfig from '@/app-modulo/comuns/email-config/router'
import usuariosInternos from '@/app-modulo/comuns/usuario-interno/router'
import servico from '@/app-modulo/comuns/servico/router'
import grupoEmpresarial from '@/app-modulo/comuns/grupo-empresarial/router'
import modelo from '@/app-modulo/documento/modelo/router'
import empresa from '@/app-modulo/comuns/empresa/router'
import certificados from '@/app-modulo/comuns/certificado/router'
import templatesEmails from '@/app-modulo/comuns/templates-gerais/shared/components/templates-email/router'
import documento from '@/app-modulo/documento/documento/router'
import portalDocumento from '@/app-modulo/documento/portal-documentos-interno/router'
import portalDocumentoExterno from '@/app-modulo/documento/portal-documentos-externo/router'
import alterarSenhaInterno from '@/app-modulo/documento/alterar-senha-interno/router'
import alterarSenhaExterno from '@/app-modulo/documento/alterar-senha-externo/router'
import esqueciSenhaInterno from '@/app-modulo/documento/esqueci-senha-interno/router'
import esqueciSenhaExterno from '@/app-modulo/documento/esqueci-senha-externo/router'
import selecionarEmpresaExterno from '@/app-modulo/documento/selecionar-empresa-externo/router'
import perfil from '@/app-modulo/comuns/perfil/router'
import indicacao from '@/app-modulo/comercial/indicacao/router'
import pessoa from '@/app-modulo/comercial/pessoa/router'
import parametrizacao from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/router'
import pacoteServico from '@/app-modulo/comercial/pacote-servico/router'
import painelProposta from '@/app-modulo/comercial/proposta/router'
import painelContrato from '@/app-modulo/comercial/contrato/router'
import tipoAtividade from '@/app-modulo/comercial/tipo-atividade/router'
import tipoTributacao from '@/app-modulo/comercial/tipo-tributacao/router'
import parametrizacaochecklist from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/router'
import log from '@/app-modulo/comuns/log/router'
import policies from '@/app-modulo/comuns/policies/router'
import portalProposta from '@/app-modulo/comercial/portal-proposta/router'
import relatorioProposta from '@/shared/components/relatorio-proposta/router'
import relatoriochecklist from '@/shared/components/relatorio-checklist/router'
import consultaConfiguravel from '@/shared/components/consulta-configuravel/router'
import confirmarAcesso from '@/app-modulo/documento/confirmar-acesso-externo/router'
import dashboardCobranca from '@/app-modulo/documento/dashboard-cobranca/router'
import template from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplate/router'
import relatorioContrato from '@/shared/components/relatorio-contrato/router'
import favoritos from '@/app-modulo/comuns/favoritos/router'
import dashboardComercial from '@/app-modulo/comercial/dashboard-comercial/router'
import configuracaoApi from '@/app-modulo/comuns/configuracao-api/router'
import parametrizacaoControleVencimento from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoControleVencimento/router'
import parametrizacaoFinanceiro from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoFinanceiro/router'
import financeiroRelatorios from '@/app-modulo/comercial/FinanceiroRelatorios/router'
import dispensaAvisoCertificadoDigial from '@/app-modulo/comuns/leading-pages/externo/desabilatar-aviso-certificado-digital/router'
import notificacoes from '@/app-modulo/comuns/notificacao/router'
import webhooks from '@/app-modulo/comuns/webhooks/router'
import documentoLicenca from '@/app-modulo/comuns/documentos-e-licencas/router'
import implantacoes from '@/app-modulo/comuns/implantacoes/router'
import emailConfigPlataforma from '@/app-modulo/plataforma/email-config/router'
import ImportacaoRegistros from '@/app-modulo/comuns/bulk-operations/router'
import workerJobs from '@/app-modulo/comuns/worker-jobs/router'
import painelOportunidades from '@/app-modulo/comercial/oportunidades/router'
import painelHonorarios from '@/app-modulo/comercial/honorarios/router'
import apolices from '@/app-modulo/comercial/apolices/router'
import configuracaoCobranca from '@/app-modulo/comercial/Parametrizacao/ConfiguracoesCobranca/router'
import templateProposta from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/router'
import templatePacote from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplatePacote/router'
import auditoria from '@/app-modulo/comuns/auditoria/router'

export default [
  ...login,
  ...loginExterno,
  ...proprietario,
  ...funcao,
  ...equipe,
  ...departamentos,
  ...dashboard,
  ...usuariosExternos,
  ...grupoUsuario,
  ...emailConfig,
  ...usuariosInternos,
  ...servico,
  ...grupoEmpresarial,
  ...modelo,
  ...empresa,
  ...certificados,
  ...templatesEmails,
  ...documento,
  ...portalDocumento,
  ...portalDocumentoExterno,
  ...alterarSenhaInterno,
  ...alterarSenhaExterno,
  ...esqueciSenhaInterno,
  ...esqueciSenhaExterno,
  ...selecionarEmpresaExterno,
  ...indicacao,
  ...pessoa,
  ...perfil,
  ...parametrizacao,
  ...pacoteServico,
  ...painelOportunidades,
  ...painelHonorarios,
  ...apolices,
  ...configuracaoCobranca,
  ...painelProposta,
  ...painelContrato,
  ...tipoAtividade,
  ...tipoTributacao,
  ...parametrizacaochecklist,
  ...log,
  ...policies,
  ...portalProposta,
  ...relatorioProposta,
  ...relatoriochecklist,
  ...consultaConfiguravel,
  ...confirmarAcesso,
  ...dashboardCobranca,
  ...template,
  ...relatorioContrato,
  ...favoritos,
  ...dashboardComercial,
  ...configuracaoApi,
  ...parametrizacaoControleVencimento,
  ...parametrizacaoFinanceiro,
  ...financeiroRelatorios,
  ...dispensaAvisoCertificadoDigial,
  ...notificacoes,
  ...webhooks,
  ...documentoLicenca,
  ...implantacoes,
  ...emailConfigPlataforma,
  ...ImportacaoRegistros,
  ...workerJobs,
  ...templateProposta,
  ...templatePacote,
  ...auditoria,
]
